import "./styles.scss";

import React from "react";

import { useMainGlobal } from "context/main-global";

import AnimatedIntersection from "components/AnimatedIntersection";
import Heading from "components/Heading";
import SimpleCard from "components/SimpleCard";
import SimpleContent from "components/SimpleContent";
import CardSlider from "components/CardSlider";

import { getColorVariant } from "utils";

const Why = ({ contents }) => {
  const { whyFeaturesData } = useMainGlobal();

  return (
    <AnimatedIntersection
      id="why-gradient"
      title="Spokój w Głowie to profesjonalna pomoc osobom w kryzysach psychologicznych."
      options={{ timeProgress: 0.33, seed: 15 }}
    >
      <div className="main-why">
        <Heading title="Dlaczego my?" />
        {whyFeaturesData?.length > 0 && (
          <div className="main-why__features">
            <h3>
              Stawiamy na <strong>holistyczne</strong> i{" "}
              <strong>kompleksowe</strong> podejście do zdrowia psychicznego
              oferując:
            </h3>
            <div className="row d-none d-sm-flex">
              {whyFeaturesData.map((item, index) => (
                <div key={index} className="col-sm-6 col-lg-4">
                  <SimpleCard
                    icon={item.icon?.sourceUrl}
                    title={item.content.title}
                    description={item.content.description}
                    variant={getColorVariant(index + 1)}
                    isEqual
                  />
                </div>
              ))}
            </div>
            <CardSlider breakpoint="sm">
              {whyFeaturesData.map((item, index) => (
                <div key={index}>
                  <SimpleCard
                    icon={item.icon?.sourceUrl}
                    title={item.content.title}
                    description={item.content.description}
                    variant={getColorVariant(index + 1)}
                    isEqual
                  />
                </div>
              ))}
            </CardSlider>
          </div>
        )}

        {contents?.length > 0 && (
          <div className="main-why__contents">
            {contents.map((item, index) => (
              <SimpleContent {...item} variant={getColorVariant(index + 1)} />
            ))}
          </div>
        )}
      </div>
    </AnimatedIntersection>
  );
};

export default Why;
